// Author YuJiaBei
// Date 2021-06-21 17:50:20

import * as model from "@/model/em/opcClient/EmOpcUaPublishRecordEouprModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmOpcUaPublishRecordEoupr(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_OPCCLIENT_URL,
    })
    .buildStore()
